@layer module {
.account-list__head {
            display: flex;
            flex-direction: column;
    }

.account-list__title-row {
            display: flex;
            align-items: center;
    }

.account-list__title {
            margin: 0;
    }

.account-list__search {
            display: flex;
            align-items: center;
            border: 1px solid;
    }

.account-list__search input {
            flex-grow: 1;
            min-width: 0;
            border: none;
            outline: none;
    }

.account-list__scroll {
            display: flex;
            flex: 1 1 0;
            flex-direction: column;
            min-height: 0;
            overflow-y: auto;
    }

.account-list__item {
            display: flex;
            flex-shrink: 0;
            align-items: center;
            width: 100%;
            border: none;
            cursor: pointer;
            text-align: left;
    }

.account-list__icon {
            flex-shrink: 0;
    }

.account-list__text {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            min-width: 0;
    }

.account-list__name-row {
            display: flex;
            align-items: center;
            min-width: 0;
    }

.account-list__name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
    }

.account-list__balance {
            white-space: nowrap;
    }

.account-list__empty {
            text-align: center;
    }

      @media (max-width: 960px) {
                .account-list__scroll {
                        flex-basis: auto;
                    }
          }
} // layer module










@layer app {
.account-list__head {
            gap: $size-12;
            padding: $size-16 $size-18 $size-8;
    }

.account-list__title-row {
            gap: $size-10;
    }

.account-list__count {
            padding: 1px $size-8;
            border-radius: $size-10;
    }

.account-list__search {
            gap: $size-8;
            height: $size-36;
            padding: 0 $size-12;
            border-radius: $size-18;
    }

.account-list__search input {
            padding: 0;
    }

.account-list__scroll {
            gap: $size-4;
            padding: $size-6 $size-10 $size-14;
    }

.account-list__item {
            gap: $size-12;
            height: $size-60;
            padding: 0 $size-12;
            border-radius: $size-14;
    }

.account-list__name-row {
            gap: $size-6;
    }

.account-list__empty {
            padding: $size-28 0 $size-8;
    }

.account-list__search input {
            background: transparent;
    }

.account-list__title {
            font-size: var(--font-size-base);
            font-weight: 500;
    }

.account-list__count {
            background: var(--bg-neutral-chip);
            color: var(--text-body);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

.account-list__search {
            background: var(--page-canvas);
            border-color: var(--border-default);
            color: var(--text-secondary);
    }

.account-list__search input {
            color: var(--text-primary);
            font-size: var(--font-size-sm);
    }

.account-list__item {
            background: transparent;
            color: var(--text-primary);
            transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    }

.account-list__item:hover {
            background: var(--bg-hover);
    }

.account-list__item.selected {
            background: var(--color-brand);
            box-shadow: var(--shadow-brand-lift);
            color: var(--color-on-brand);
    }

.account-list__name,
.account-list__balance {
            font-size: var(--font-size-base);
            font-weight: 500;
    }

.account-list__balance {
            font-variant-numeric: tabular-nums;
    }

.account-list__currency {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }

.selected .account-list__currency {
            color: var(--hero-text-soft);
    }

.account-list__icon {
            box-shadow: var(--shadow-account-list-marker);
    }

.account-list__empty {
            color: var(--text-secondary);
            font-size: var(--font-size-base);
    }
} // layer app
